export type CanvasImageSourceWithoutSVG =
  | HTMLVideoElement
  | HTMLImageElement
  | HTMLCanvasElement
  | OffscreenCanvas
  | ImageBitmap;

export function getImageDimensions(image: CanvasImageSourceWithoutSVG): {
  width: number;
  height: number;
} {
  let { width, height } = image;

  // Comparing names because instanceof doesn't work in portals
  // to popup windows opened using window.open
  // https://www.anycodings.com/1questions/5835120/react-portal-to-popup-creates-instanceof-mismatch

  if (image.constructor.name === 'HTMLImageElement') {
    ({ naturalWidth: width, naturalHeight: height } = image as HTMLImageElement);
  } else if (image.constructor.name === 'HTMLVideoElement') {
    ({ videoWidth: width, videoHeight: height } = image as HTMLVideoElement);
  } else if (
    image.constructor.name === 'HTMLCanvasElement' ||
    image.constructor.name === 'OffscreenCanvas' ||
    image.constructor.name === 'ImageBitmap'
  ) {
    ({ width, height } = image);
  }

  return { width, height };
}
